const config = {};

config.STAGING = {
  tdnMoniker: "StagingTDN",
  backendUrl: "https://api.treasury-staging.todaq.net",
};

config.PROD = {
  tdnMoniker: "TDN",
  backendUrl: "https://api.treasury.todaq.net",
};

export default config;
